import React, { useState, useMemo, useEffect } from 'react';

import { useSelector } from 'react-redux';

import './DescriptionPlan.css';
import webchat from '../../../assets/images/webchat_icon.svg';
import messenger from '../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../assets/images/whatsapp_icon.svg';
import instagram from '../../../assets/images/instagram_icon.svg';

export default function DescriptionPlan(props) {
  const { viewPage, setViewPage } = props;

  const [currentPlan, setCurrentPlan] = useState(null);
  const company = useSelector((state) => state.companies.company);

  useEffect(() => {
    setCurrentPlan(company?.plan);
  }, [company]);

  const channelsIcon = (channel) => {
    const channels = {
      webchat,
      messenger,
      whatsapp,
      instagram,
    };
    return channels[channel];
  };

  const isView = useMemo(() => {
    return viewPage === 'view';
  }, [viewPage]);

  return (
    <div
      className={
        isView
          ? 'w-290 plan-container description-plan-container'
          : 'plan-container description-plan-container'
      }
    >
      <div className="w-100">
        <p className="user-plan-title">Plano</p>
        <div className="container-corporate">
          <p>{currentPlan?.name}</p>
          {!isView && (
            <button onClick={() => setViewPage('view')} type="button">
              mudar plano
            </button>
          )}
        </div>

        <div className="divider-plan" />

        {currentPlan?.name?.toLowerCase() === 'freemium' ? (
          <div className="container-img-channels-plan">
            <img src={channelsIcon('webchat')} alt="webchat" />
            {/* <img src={channelsIcon('messenger')} alt="messenger" /> */}
            <p>1000 conversas/mês</p>
          </div>
        ) : (
          <div className="container-img-channels-plan">
            <img src={channelsIcon('whatsapp')} alt="whatsapp" />
            <p>{currentPlan?.amountWhatsappConversation} conversas/mês</p>
          </div>
        )}
      </div>
    </div>
  );
}
